import * as React from "react";
import { twMerge } from "tailwind-merge";

export const Kbd = React.forwardRef<HTMLElement, React.ComponentPropsWithoutRef<"kbd">>(
  ({ className, ...rest }, ref) => {
    return (
      <kbd
        className={twMerge(
          "border-ds-stroke-secondary bg-ds-surface-2 text-ds-text-secondary pointer-events-none inline-flex h-5 items-center gap-1 rounded-sm border border-solid px-1.5 font-mono text-xs leading-none font-medium opacity-100 shadow-xs select-none",
          className,
        )}
        ref={ref}
        {...rest}
      />
    );
  },
);
Kbd.displayName = "Kbd";
